// extracted by mini-css-extract-plugin
export default {"loading":"styles_loading__jVZoM","spin":"styles_spin__JDrwt","pulse":"styles_pulse__H8g+g"};